import { storyblokInit, apiPlugin, type SbReactComponentsMap } from '@storyblok/react'

let initialized = false
let componentsRegistered = false

// Idempotently initialise the Storyblok SDK
export const ensureStoryblokInit = (
  components: SbReactComponentsMap = {}
): void => {
  const hasComponents = Object.keys(components).length > 0

  if (initialized && (componentsRegistered || !hasComponents)) {
    return
  }

  storyblokInit({
    accessToken: process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN,
    use: [apiPlugin],
    components,
    apiOptions: {
      region: '',
      rateLimit: 20,
      maxRetries: 3,
      cache: {
        type: 'memory',
        clear: 'auto'
      }
    }
  })

  initialized = true
  componentsRegistered = componentsRegistered || hasComponents
}
